import { createFileRoute } from '@tanstack/react-router';
import { Bell, Mail, MessageSquare, Smartphone } from 'lucide-react';

export const Route = createFileRoute('/_app/settings/notifications')({
  component: NotificationsPage,
});

// Placeholder honesto. La funcionalidad llega en Sprint Notificaciones —
// fuera de scope del Sprint Settings Panel IA.
function NotificationsPage() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Notificaciones</h1>
        <p className="mt-1 text-sm text-[color:var(--color-fg-muted)]">
          Configurá qué notificaciones recibís y por qué canal.
        </p>
      </header>

      <ComingSoonCard>
        <p>
          <strong>Próximamente.</strong> Vas a poder activar/desactivar
          notificaciones por evento (nueva tarea asignada, cliente sin
          respuesta &gt;48h, factura vencida, alertas SII, etc.) y elegir
          el canal por preferencia.
        </p>
      </ComingSoonCard>

      <ChannelMockups />
    </div>
  );
}

function ChannelMockups() {
  const channels = [
    { icon: <Mail className="h-5 w-5" />, name: 'Email', detail: 'Resúmenes diarios + alertas críticas inmediatas' },
    { icon: <Smartphone className="h-5 w-5" />, name: 'Push (mobile)', detail: 'App nativa pendiente de release' },
    { icon: <MessageSquare className="h-5 w-5" />, name: 'WhatsApp', detail: 'Solo eventos críticos (cliente urgente, fallas SII)' },
    { icon: <Bell className="h-5 w-5" />, name: 'In-app', detail: 'Notificación dentro del portal' },
  ];
  return (
    <section className="space-y-3">
      <h2 className="text-sm font-semibold">Canales planeados</h2>
      <div className="grid gap-3 sm:grid-cols-2">
        {channels.map((c) => (
          <div
            key={c.name}
            className="flex gap-3 rounded-lg border p-4"
            style={{
              background: 'var(--color-bg-elevated)',
              borderColor: 'var(--color-border)',
            }}
          >
            <div
              className="shrink-0 rounded-md p-2"
              style={{ background: 'var(--color-bg-overlay)', color: 'var(--color-fg-muted)' }}
            >
              {c.icon}
            </div>
            <div>
              <div className="text-sm font-medium">{c.name}</div>
              <div className="mt-0.5 text-xs text-[color:var(--color-fg-muted)]">{c.detail}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

function ComingSoonCard({ children }: { readonly children: React.ReactNode }) {
  return (
    <div
      className="rounded-lg border p-5 text-sm"
      style={{
        background: 'var(--color-bg-overlay)',
        borderColor: 'var(--color-border)',
        color: 'var(--color-fg)',
      }}
    >
      {children}
    </div>
  );
}
